class ProductCardSubscription extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.subscriptionField = this.querySelector("[js-subscription-field]");
        this.subscriptionField.addEventListener("change", this.handleSubscription.bind(this))
    }

    handleSubscription({ target }) {
        const productCard = target.closest("[js-product-wrapper]");
        const sellingPlanField = productCard.querySelector("[js-selling-plan-field]");

        if(target.checked) {
            productCard.classList.add("is-subscription-enabled");
            sellingPlanField.value = target.getAttribute("data-selling-plan-id");
        }else {
            productCard.classList.remove("is-subscription-enabled");
            sellingPlanField.value = "";
        }
    }
}

customElements.define('product-card-subscription', ProductCardSubscription);

class ProductCardSubscriptionFrequency extends HTMLElement {
    constructor() {
      super();

      this.dropdown = null;
      this.toggleButton = null;
    }
  
    connectedCallback() {
      this.dropdown = this.querySelector('[js-subscription-dropdown]');
      this.toggleButton = this.querySelector('[js-subscription-btn]');
      this.options = this.querySelectorAll('[js-purchase-option]');
  
      if (this.toggleButton && this.dropdown) {
        this.addEventListeners();
      }
    }
  
    addEventListeners() {
      this.toggleButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggleDropdown();
      });
  
      this.options.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.stopPropagation();
          this.selectOption(option);
        });
      });
  
      document.addEventListener('click', () => {
        this.closeDropdown();
      });
    }
  
    toggleDropdown() {
      this.dropdown.classList.toggle("is-open")
    }
  
    closeDropdown() {
        this.dropdown.classList.remove("is-open")
    }
  
    selectOption(option) {
        const productCard = option.closest("[js-product-wrapper]");
        const subscriptionField = productCard.querySelector("[js-subscription-field]");
        const sellingPlanField = productCard.querySelector("[js-selling-plan-field]");
        this.options.forEach((opt) => opt.classList.remove('is-active'));
    
        option.classList.add('is-active');
    
        const label = this.toggleButton.querySelector('[js-select-label]');
        const sellingPlanName = option.getAttribute("data-selling-plan-name");
        const sellingPlanId = option.getAttribute("data-selling-plan-id");

        if (label) {
            label.textContent = sellingPlanName;
        }
        sellingPlanField.value = sellingPlanId;
        subscriptionField.setAttribute("data-selling-plan-id", sellingPlanId)
    
        this.closeDropdown();
    }
  }
  
  customElements.define('product-card-subscription-frequency', ProductCardSubscriptionFrequency);
  